import React from 'react';
import { ZAvatar, ContextMenuComplete } from '@marageti/z4-lib';
import { Agent } from '@marageti/z4-sdk/lib/people';
import { Card, CardHeader } from '@mui/material';

type SpecialistCardProps = {
  isAdmin: boolean,
  openModal: () => void
  specialist: Agent | undefined,
};

const SpecialistCard = ({ isAdmin, openModal, specialist }: SpecialistCardProps) => {
  const {
    id, fullName, avatar,
  } = specialist || {};

  const contextMenuAction = isAdmin ? (
    <ContextMenuComplete
      id="re-assign-agent"
      items={[{ action: openModal, label: 'Reassign' }]}
    />
  ) : null;

  return (
    <Card
      key={id}
      sx={{ width: '100%' }}
    >
      <CardHeader
        titleTypographyProps={{ variant: 'h3' }}
        title={fullName}
        subheader="Assigned Specialist"
        avatar={(
          <ZAvatar
            src={avatar}
            name={fullName}
            loading={!specialist}
            size={40}
          />
        )}
        action={contextMenuAction}
      />
    </Card>
  );
};

export default SpecialistCard;
